import React from 'react';

import { RoomTypeID } from '@kamernet/core/ApiClient/Kamernet';

import { ContentCountryAntisquat } from './ContentCountryAntisquat';
import { ContentCountryApartment } from './ContentCountryApartment';
import { ContentCountryGeneric } from './ContentCountryGeneric';
import { ContentCountryRoom } from './ContentCountryRoom';
import { ContentCountryStudentHousing } from './ContentCountryStudentHousing';
import { ContentCountryStudio } from './ContentCountryStudio';

export interface ContentCountryProps {
  listingTypeIds: RoomTypeID[];
}

export const ContentCountry = ({ listingTypeIds }: ContentCountryProps) => {
  if (listingTypeIds.length !== 1) {
    return <ContentCountryGeneric />;
  }

  switch (listingTypeIds[0]) {
    case RoomTypeID.Room:
      return <ContentCountryRoom />;
    case RoomTypeID.Apartment:
      return <ContentCountryApartment />;
    case RoomTypeID.Studio:
      return <ContentCountryStudio />;
    case RoomTypeID.Antikraak:
      return <ContentCountryAntisquat />;
    case RoomTypeID.StudentResidence:
      return <ContentCountryStudentHousing />;
    default:
      return <ContentCountryGeneric />;
  }
};
